import api from '~/services/api';
import { ChangePaymentMethodPayload, PaymentMethodsJson } from '~/types/PaymentMethods';

function apiFetchPaymentMethods() {
  return api.request<PaymentMethodsJson>({
    url: 'v1/billing/',
    method: 'GET',
  });
}

function apiChangePaymentMethod(payload: ChangePaymentMethodPayload) {
  return api.request<PaymentMethodsJson>({
    url: 'v1/billing/',
    method: 'POST',
    data: payload,
  });
}

export { apiFetchPaymentMethods, apiChangePaymentMethod };
